import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import AccountsEditForm from './AccountsEditForm';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchAccount } from 'store/actions/accounts/fetchAccounts';
import { updateAccount } from 'store/actions/accounts/updateAccounts';

class AccountsEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    resolve();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/accounts/${ id }/show`));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const info = `${ data.name } (${ data.id })`;

        const breadcrumbs = [
            {
                label: translate('resources.accounts.title'),
                link: '/accounts',
            },
            {
                label: info,
                link: `/accounts/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.accounts.actions.edit') } />

                    <Actions>
                        <ListButton url='/accounts' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <AccountsEditForm
                            data={ data }
                            form='accounts_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                            resource={ resource }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

AccountsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateAccount(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        resource: 'accounts',
        action: fetchAccount,
    }),
);

export default enhance(AccountsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/edit/AccountsEditContainer.js